class OrderPayment {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-order-payment="scope"]',
			optionWrapper: '[data-order-payment="option-wrapper"]',
			option: '[data-order-payment="option"]',
			extra: '[data-order-payment="extra"]',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
		this.$scope.find(this.config.extra).each((index, element) => this.closeExtra($(element)));
		let $activeExtra = this.$scope.find(`${this.config.option}:checked`).closest(this.config.optionWrapper).find(this.config.extra);
		$activeExtra.each((index, element) => this.openExtra($(element)));
	}

	addEventListeners() {
		this.$scope.on('change', this.config.option, this.toggleExtra.bind(this));
	}

	toggleExtra(event) {
		let $option = $(event.currentTarget);
		let $scope = $option.closest(this.config.scope);
		$scope.find(this.config.extra).each((index, element) => this.closeExtra($(element)));

		let $extra = $option.closest(this.config.optionWrapper).find(this.config.extra);
		$extra.each((index, element) => this.openExtra($(element)));
	}

	openExtra($extra) {
		$extra.find(':input').attr('disabled', false);
		$extra.removeClass('d-none');
	}

	closeExtra($extra) {
		$extra.find(':input').attr('disabled', true);
		$extra.addClass('d-none');
	}
}

export default new OrderPayment;